export const ProtocolEnum = Object.freeze({
  SFTP: 'SFTP'
});